<script lang="ts">
	import Container from '$lib/components/ui/container/container.svelte';
	import ChampionMatchupBuilds from './_components/champion-matchup-builds.svelte';
	import CounterPicks from './_components/counter-picks.svelte';
	import GameKnowledge from './_components/game-knowledge.svelte';
	import MatchupTips from './_components/matchup-tips.svelte';
	import MicroMacro from './_components/micro-macro.svelte';
	import PersonalizedProactive from './_components/personalized-proactive.svelte';
	import TierLists from './_components/tier-lists.svelte';
	import Vods from './_components/vods.svelte';
</script>

<Container class="relative mb-12 gap-12" id="features">
	<div class="bg-spotlight-medium -top-12 mx-auto hidden aspect-square max-w-full sm:block" />
	<div class="bg-lines-pattern top-36 max-h-[200px] max-w-full" />
	<div class="mx-auto grid max-w-2xl grid-cols-1 gap-3 lg:mx-0 lg:max-w-none">
		<span class="text-center text-sm text-primary">Use cases</span>
		<h2 class="text-center text-4xl sm:text-5xl">Meeko is at your service</h2>
		<p class="max-w-xl px-2 text-center font-light tracking-wider text-lightTertiary">
			Explore how Meeko can help you with your League of Legends journey
		</p>
	</div>
	<div class="mt-8 flex w-full flex-col gap-3">
		<div class="mx-auto grid h-full w-full grid-cols-1 gap-3 md:grid-cols-2 lg:max-w-none">
			<ChampionMatchupBuilds />
			<TierLists />
		</div>
		<div
			class="mx-auto grid w-full grid-cols-1 gap-3 sm:mt-0 md:grid-cols-2 md:grid-rows-2 lg:max-w-none lg:grid-cols-3"
		>
			<CounterPicks />
			<PersonalizedProactive />
			<MicroMacro />
			<MatchupTips />
			<Vods />
			<GameKnowledge />
		</div>
	</div>
</Container>
